import type { UndefinedOnPartialDeep } from 'type-fest';

import Text from '@ingka/text';
import { translate } from '@repo/phrase';
import { type Service, isPickupServiceType } from '@repo/types/service';

import { useAssetParams } from '@/hooks/asset.hooks';
import { formatOpeningHours } from '@/utils/opening-hours.utils';

import styles from './styles.module.scss';

interface Props {
    service: UndefinedOnPartialDeep<Service>;
    estimatedDeliveryTime: string | undefined;
}

export const ArticleDeliveryTimeText = ({ service, estimatedDeliveryTime }: Props) => {
    const { assetType } = useAssetParams();

    const { serviceType, pickupPoint } = service;

    const deliveryTimeFallback = <Text>{translate('services_article_delivery_view_delivery_time_NOT_FOUND')}</Text>;

    if (!serviceType) {
        return deliveryTimeFallback;
    }

    let deliveryTime;

    if (isPickupServiceType(serviceType) && pickupPoint?.openingHours) {
        deliveryTime = (
            <div className={styles.article_delivery_opening_hours_container}>
                {Object.entries(formatOpeningHours(pickupPoint.openingHours, assetType)).map(([days, workingHours]) => (
                    <div className={styles.article_delivery_opening_hours} key={days}>
                        <Text className={`${styles.article_delivery_opening_hours_days}`}>{`${days},`}</Text>
                        <Text className={`${styles.article_delivery_opening_hours_hours}`}>{workingHours}</Text>
                    </div>
                ))}
            </div>
        );
    } else if (estimatedDeliveryTime) {
        deliveryTime = <Text>{estimatedDeliveryTime}</Text>;
    } else {
        deliveryTime = deliveryTimeFallback;
    }

    return deliveryTime;
};
